// extracted by mini-css-extract-plugin
export default {"Slider":"styles_Slider__nZJOm","mediaContainer":"styles_mediaContainer__-9A9f","switchButton":"styles_switchButton__HkY-j"};